import { useEffect, useState } from 'react';
import createPlotlyComponent from 'react-plotly.js/factory';

// Global state to track loading
let plotlyLoadingPromise = null;

function loadPlotly() {
  // Return existing promise if already loading
  if (plotlyLoadingPromise) {
    return plotlyLoadingPromise;
  }

  // Already loaded
  if (window.Plotly) {
    return Promise.resolve();
  }

  // Create new loading promise
  plotlyLoadingPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://cdn.plot.ly/plotly-3.1.1.min.js';
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Plotly'));
    document.body.appendChild(script);
  });

  return plotlyLoadingPromise;
}

// Create Plot component once Plotly is loaded
let PlotComponent = null;

export default function PlotlyChart({ data, layout = {}, config = {}, ...props }) {
  const [plotlyLoaded, setPlotlyLoaded] = useState(!!window.Plotly);

  useEffect(() => {
    loadPlotly().then(() => {
      if (!PlotComponent) {
        PlotComponent = createPlotlyComponent(window.Plotly);
      }
      setPlotlyLoaded(true);
    });
  }, []);

  if (!plotlyLoaded || !PlotComponent) {
    return <div>Loading chart...</div>;
  }

  return <PlotComponent data={data} layout={layout} config={config} {...props} />;
}
